export default __webpack_public_path__ + "static/media/edit.83509d61.svg";